import api from "../..";
import type { User, GetUsersParams } from "./types";

const normalizeUsersResponse = (payload: unknown): User[] => {
  if (Array.isArray(payload)) return payload;
  if (payload && typeof payload === "object") {
    const data = payload as { data?: unknown; results?: unknown };
    if (Array.isArray(data.data)) return data.data;
    if (Array.isArray(data.results)) return data.results;
  }
  return [];
};

export const getUsers = async ({ params }: GetUsersParams = {}): Promise<User[]> => {
  try {
    const res = await api.get("/accounts/", { params });
    return normalizeUsersResponse(res.data);
  } catch {
    return [];
  }
};